import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import { useDispatch } from "react-redux";
import {  getDriverById, updateDriver } from "../../../redux/driver/action";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import { usePermissions } from "../../../Hooks/usePermissions";
import { MENU, PERMISSION } from "../../../lib/permissions";





const UpdateDriver = () => {
    const selectedDriver = useSelector(({ driver: { driverbyid } }) => driverbyid);
      const { id } = useParams()
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hasAction } = usePermissions();

  const validationSchema = Yup.object({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email_id: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    country_code: Yup.string().required("Country code is required"),
    mobile_number: Yup.string()
      .required("Mobile number is required")
      .matches(/^\d+$/, "Only digits allowed"),
  });
  
  //   update
  useEffect(() => {
      if (id) {
        dispatch(getDriverById(id));
      //   setUpdate(true);
      }
    }, [id]);
  
  
    console.log(selectedDriver,"selectedDriver")

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      status: selectedDriver?.status || 1,
      first_name: selectedDriver?.first_name || "" ,
      last_name: selectedDriver?.last_name || "",
      email_id:  selectedDriver?.email_id ||"",
      country_code: selectedDriver?.country_code || "+966",
      mobile_number: selectedDriver?.mobile_number || "",
    },
    validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

    const statusOptions = [
    { value: 1, label: "Active" },
    { value: 2, label: "Inactive" },
  ];


  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id,
    };
    dispatch(updateDriver(data, setLoading, navigate));
  };

// permission

  const isEditable = hasAction(MENU.DRIVER, PERMISSION.EDIT);

  return (
    <div className="card-head order-card order-timing">
        <h3 className="pb-3">Update Driver</h3>
      <form onSubmit={formik.handleSubmit} className="form row">
        {/* First Name */}
        <div className="col-md-6">
          <label>First Name</label>
          <CustomInput
          disabled={!isEditable}
            name="first_name"
             placeholder="Enter First Name"
            value={formik.values.first_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.first_name && formik.errors.first_name && (
            <small className="text-danger">{formik.errors.first_name}</small>
          )}
        </div>

        {/* Last Name */}
        <div className="col-md-6">
          <label>Last Name</label>
          <CustomInput
          disabled={!isEditable}
            name="last_name"
             placeholder="Enter Last Name"
            value={formik.values.last_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.last_name && formik.errors.last_name && (
            <small className="text-danger">{formik.errors.last_name}</small>
          )}
        </div>

        {/* Email */}
        <div className="col-md-6">
          <label>Email ID</label>
          <CustomInput
          disabled={!isEditable}
            name="email_id"
            type="email"
            placeholder="Enter Email ID"
            value={formik.values.email_id}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.email_id && formik.errors.email_id && (
            <small className="text-danger">{formik.errors.email_id}</small>
          )}
        </div>

        {/* Phone Input */}
        <div className="col-md-6">
          <label>Mobile Number</label>
          <div className="row ">
            <div className="col-md-3 col-4 pr-0">
              <PhoneInput
               disabled={!isEditable}
                country={"sa"}
                value={formik.values.country_code}
                onChange={(value, data) => {
                  formik.setFieldValue("country_code", `+${data.dialCode}`);
                }}
                inputProps={{ readOnly: true }}
                inputStyle={{
                  paddingLeft: "38px",
                  paddingRight: "8px",
                  width: "100%",
                }}
              />
              {formik.touched.country_code && formik.errors.country_code && (
                <small className="text-danger">{formik.errors.country_code}</small>
              )}
            </div>

            <div className="col-md-9 col-8 pl-0">
              <input
                disabled={!isEditable}
                type="text"
                name="mobile_number"
                className="form-control mobile-input-res"
                placeholder="Mobile number"
                value={formik.values.mobile_number}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.mobile_number && formik.errors.mobile_number && (
                <small className="text-danger">{formik.errors.mobile_number}</small>
              )}

               
          </div>
        </div>
        <div className="col-md-6">
                  <label>Status</label>
                  <ReactSelect
                    id="status"
                    name="status"
                    options={statusOptions}
                    placeholder="Select Status"
                    value={statusOptions.find(
                      (option) => option.value === formik.values.status
                    )}
                    onChange={(option) =>
                      formik.setFieldValue("status", option.value)
                    }
                    onBlur={formik.handleBlur}
                    isDisabled={!isEditable}
                  />
                  {formik.touched.status && formik.errors.status && (
                    <div className="error">{formik.errors.status}</div>
                  )}
                </div>

        {/* Submit Button */}
        <div className="col-12 d-flex justify-content-between align-items-center mt-4">
           <button
                    className="back-btn"
                    disabled={loading}
                    onClick={() => navigate("/driverlist")}
                    type="button"
                  >
                    Back
                  </button>
          {isEditable && (
            <button
            className="submit-btn"
            style={{ width: "max-content" }}
            type="submit"
            disabled={loading}
          >
            {!loading ? "Submit" : <Spinner />}
          </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default UpdateDriver;
